export const i18nModelPage = {
  sections: {
    risk: 'Risk Score',
    alarmHistory: 'Model alarm history',
    radar: 'Radar view',
    amoeba: 'Plot view',
    models: 'Process Models',
  },
};
